export * as model from './model'

import { COMPONENT, register } from '~/core/repository'
import { PlayerTrailer } from './ui'

register(PlayerTrailer, 'PlayerTrailer', COMPONENT)
